import { callGraphQLEndpoint } from '../../../Module/graphQL'

const createClientByPlatform = input => {
  const sql = `mutation createClientFromPlatform($input: CreateClientFromPlatformInput) {
      createClientFromPlatform(input: $input){
        success
        error,
        clientId,
        userId,
        authToken
        }
    }`
  return callGraphQLEndpoint('', sql, { input }, {}, {}, false)
}

const checkIfUserExist = email => {
  const sql = `query isExistUserWithEmail($email: String!) {
      isExistUser(email: $email)
    }`

  return callGraphQLEndpoint('', sql, { email }, {}, {}, false)
}

const checkIfClientExist = name => {
  const sql = `query isExistClient($name: String!) {
      isExistClient(name: $name)
    }`
  return callGraphQLEndpoint('', sql, { name }, {}, {}, false)
}

export { createClientByPlatform, checkIfUserExist, checkIfClientExist }
